import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../Services/translation';
import StackedPrices from './StackedPrices';
import PanelSubmit from './PanelSubmit';
import ConfiguratorProductDetails from './ConfiguratorProductDetails';
import { changeProductServiceTab } from '../../Actions/Configurator.action';
import ProductQuantitySelector from './ProductQuantitySelector';
import PanelBlasting from './PanelBlasting';
import PanelMarking from './PanelMarking';
import PanelGoodsMarking from './PanelGoodsMarking';
import PanelDeliveryDate from './PanelDeliveryDate';

import closeIcon from '../../../images/closeDialogIcon.svg';

const ProductServiceBlasting = () => {
  const dispatch = useDispatch();

  return (
    <Fragment>
      <a className='configurator-close-button' onClick={() => dispatch(changeProductServiceTab(0))}><img src={closeIcon} /></a>
      <div className='configurator-header'>
        <h4>{translate('blasting.title')}</h4>
      </div>
      <ConfiguratorProductDetails useLongName={true} />
      <StackedPrices />
      <ProductQuantitySelector />
      <PanelBlasting />
      <PanelMarking IsPopup={false} />
      <PanelGoodsMarking
        icon='marking'
        labelKey='configurator.goodsmarking.key'
        setting='goodsMarking'
      ></PanelGoodsMarking>
      <PanelDeliveryDate
        icon='delivery'
        labelKey='configurator.deliveryDate.key'
        setting='deliveryDate'
      ></PanelDeliveryDate>
      <PanelSubmit />
    </Fragment>
  );
};

export default ProductServiceBlasting;
